import { render, staticRenderFns } from "./LiuexPrepositionsPhone.vue?vue&type=template&id=6fbf2280&"
import script from "./LiuexPrepositionsPhone.vue?vue&type=script&lang=js&"
export * from "./LiuexPrepositionsPhone.vue?vue&type=script&lang=js&"
import style0 from "./LiuexPrepositionsPhone.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Ftips-phone&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports